<template>
    <div class="loader-icon-wrapper" id="loader-icon-wrapper" v-if="isActive">
      <img id="loader-icon" src="@/assets/dual-ring-loader-transparent.gif" alt="loader icon" />
    </div>
</template>

<script>
    export default {
      name: "Loader",
      props: ["isActive"]
    }
</script>

<style lang="less" scoped>
  .loader-icon-wrapper {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
  }

  #loader-icon {
    width: 50px;
    position: absolute;
    width: 50px;
    bottom: 100px;
    left: 51.5%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
</style>